export default __webpack_public_path__ + "static/chatlab-landscape-tile-a5522a1263399001047aa3e5e5a6d548.svg";